<template>
  <ApexCharts
    ref="chart"
    :class="`${name}-chart`"
    type="line"
    height="100%"
    :options="chartOptions"
    :series="currentSeries"
  />
</template>

<script>

import VueApexCharts from "vue3-apexcharts";

export default {
  name: 'TrainingChartSingle',
  components: {
    ApexCharts: VueApexCharts,
  },
  props: {
    isFullScreen: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
    series: {
      type: Object,
      default: () => {},
    },
    labels: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isZoomed: false,
      currentSeries: [],
      currentLabels: [],
      chartOptions: {
        chart: {
          height: '100%',
          type: 'line',
          zoom: {
            enabled: false,
          },
          animations: {
            enabled: false,
          },
        },
        stroke: {
          width: 2,
        },
        labels: this.labels,
        title: {
          text: this.name,
          align: 'center',
        },
        xaxis: {
          tickAmount: this.labels.length / 10,
        },
        yaxis: {
          decimalsInFloat: 4,
        },

      },
    };
  },
  watch: {
    series: {
      handler(newVal) {
        if (this.$refs.chart?.updateSeries) {
          if (newVal.length !== this.currentSeries.length) {
            this.currentSeries = newVal;
            this.$refs.chart.updateSeries(this.currentSeries, false);
          }
        }
      },
      deep: true,
    },
    labels: {
      handler(newLabels) {
        if (this.$refs.chart?.updateOptions) {
          if (newLabels.length !== this.currentLabels.length) {
            this.currentLabels = newLabels;
            const newOptions = { ...this.chartOptions };
            newOptions.labels = this.currentLabels;
            newOptions.xaxis.tickAmount = this.currentLabels.length / 10;
            this.$refs.chart.updateOptions(newOptions, false, false);
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    setTimeout(() => {
      if (this.$refs.chart?.updateSeries) {
        this.$refs.chart.updateSeries(this.series, false);
      }
    }, 500);
  },
};
</script>

  <style lang="scss" scoped>

  </style>
